import { render } from "./Cp001.vue?vue&type=template&id=916ff152&scoped=true"
import script from "./Cp001.vue?vue&type=script&lang=js"
export * from "./Cp001.vue?vue&type=script&lang=js"

import "./Cp001.vue?vue&type=style&index=0&id=916ff152&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916ff152"]])

export default __exports__